/**
 * @description Object encoding schemes
 */
export enum EncodingScheme {
	BASE_64 = 'base64'
}